import {Airline} from '@/redux/slice/userSlice';

export const getAirline = () => {
  const airline = localStorage.getItem('airline');
  if (airline === Airline.ACML1) {
    return Airline.SIA;
  }
  if (airline) {
    return airline;
  }
  return Airline.SIA;
};

export const transformAirline = (airline: string) => {
  if (airline === Airline.ACML1) {
    return Airline.SIA;
  }
  return airline;
};
